import FormErrorHelper from './FormErrorHelper'

export default {
  inject: ['formErrors', 'handleError'],

  mixins: [FormErrorHelper]

}
